import config from '../config';

let store = {};
const callbacks = [];

/**
 * Load the Google maps library
 *
 * @param {object} vuexStore
 * @param {function|null} aCallback
 */
export default function mapsLoader(vuexStore, callback = null) {
    store = vuexStore;
    callbacks.push(callback);
    const key = config.googleMapsApiKey;

    if (!store.state.googleMaps.isReady && !store.state.googleMaps.isLoading) {
        store.dispatch('googleMaps/setLoading');
        const lang = store.state.locale;
        const scriptTag = document.createElement('script');
        const firstScriptTag = document.getElementsByTagName('script')[0];
        scriptTag.src = `https://maps.googleapis.com/maps/api/js?libraries=places&callback=initializeMaps&language=${lang}&key=${key}`;
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
    }
}

if (process.client) {
    window.initializeMaps = () => {
        store.dispatch('googleMaps/setReady');
        if (callbacks.length) {
            callbacks.forEach((callback) => {
                if (typeof callback === 'function') {
                    callback();
                }
            });
        }
    };
}
